import { useEffect, useState } from "react";
import { TEXT_PREVIEW_MAX_CHARS } from "./utils";

export function useTextFilePreview(enabled: boolean, url: string | null | undefined) {
  const [content, setContent] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled || !url?.trim()) {
      setContent(null);
      setLoading(false);
      setError(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(false);
    setContent(null);

    void fetch(url)
      .then(async (res) => {
        if (!res.ok) throw new Error("Failed to load text file");
        const text = await res.text();
        if (text.length > TEXT_PREVIEW_MAX_CHARS) {
          return `${text.slice(0, TEXT_PREVIEW_MAX_CHARS)}\n\n… (preview truncated)`;
        }
        return text;
      })
      .then((text) => {
        if (!cancelled) setContent(text);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, url]);

  return { content, loading, error };
}
